module.exports = __webpack_public_path__ + "static/media/lt-surge-intro-3.fb7cfda1.wav";